import { openDB } from "idb";

const dbPromise = openDB("giftTableDB", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("photos")) {
      db.createObjectStore("photos");
    }
    if (!db.objectStoreNames.contains("media")) {
      db.createObjectStore("media");
    }
  },
});

export const setPhoto = async (id: string, photo: string) => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("photos")) {
    return;
  }
  await db.put("photos", photo, id);
};

export const getPhoto = async (id: string) => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("photos")) {
    return null;
  }
  return await db.get("photos", id);
};

export const clearAllPhotos = async () => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("photos")) {
    return;
  }
  await db.clear("photos");
};

export const setMedia = async (id: string, media: string) => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("media")) {
    // Object store "media" does not exist, so exit gracefully.
    return;
  }
  await db.put("media", media, id);
};

export const getMedia = async (id: string) => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("media")) {
    // Return a nullish value if the "media" store is missing.
    return null;
  }
  return await db.get("media", id);
};

export const clearAllMedia = async () => {
  const db = await dbPromise;
  if (!db.objectStoreNames.contains("media")) {
    return;
  }
  await db.clear("media");
};
